import React, { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import {
	CssBaseline,
	Container,
	Paper,
	Typography,
	Button,
	TextField,
} from '@material-ui/core';
import { Helmet } from 'react-helmet-async';
import { NavLink, useNavigate } from 'react-router-dom';
import {
	useDeleteAuthorMutation,
	useDeleteCategoryMutation,
	useUpdateAuthorMutation,
	useUpdateCategoryMutation,
} from '../../../store/apiSlice';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
	},
	title: {
		paddingBottom: theme.spacing(2),
	},
	backButton: {
		marginBottom: theme.spacing(2),
	},
}));

export function CategoryDetails(props) {
	const classes = useStyles();
	const { id } = useParams();
	const location = useLocation();

	const categoryName = location.state?.name;
	const navigate = useNavigate();
	const [deleteAuthor] = useDeleteCategoryMutation();
	const handleDelete = (e) => {
		deleteAuthor({ id });
		navigate('/admin/categories');
	};

	const [updateAuthor] = useUpdateCategoryMutation();
	const handleUpdate = (e) => {
		updateAuthor({ id, name: newAuthorName });
		navigate('/admin/categories');
	};

	const [newAuthorName, setNewAuthorName] = useState(categoryName || '');

	return (
		<div className={classes.root}>
			<CssBaseline />
			<Helmet>
				<title>Детайли: Категория</title>
			</Helmet>

			<Container maxWidth="lg" className={classes.container}>
				<Paper className={classes.paper}>
					<Typography
						className={classes.title}
						component="h1"
						variant="h4"
						role="alert"
					>
						Детайли
					</Typography>

					<Typography
						className={classes.title}
						component="h2"
						variant="h6"
						role="alert"
					>
						Име: {categoryName || 'Няма намерена категория.'}
					</Typography>

					<div className={classes.paper}>
						<Typography>Редактирай името на категорията:</Typography>
						<TextField
							value={newAuthorName}
							onChange={(e) => setNewAuthorName(e.target.value)}
							placeholder="Име на автора"
						></TextField>
					</div>
					<Button startIcon={<EditIcon />} onClick={handleUpdate}>
						Запис
					</Button>
					<Button startIcon={<DeleteIcon />} onClick={handleDelete}>
						Изтрий
					</Button>
				</Paper>
			</Container>
		</div>
	);
}
